import { clsx } from 'clsx'
import { memo, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, shallowEqual } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { DEFAULT_ANIMATION_IN } from '@shared/config'
import { Btn } from '@shared/ui/btn'
import { NotchLoader } from '@shared/ui/loader'
import { FullCenterContent } from '@shared/ui/wrappers'

import styles from './styles.module.scss'

// TODO add smooth fadeOut
const FCFullPageLoader = () => {
  const { t } = useTranslation('buttons')

  const navigate = useNavigate()

  const loader = useSelector((state) => state.loader, shallowEqual)

  const [isRetry, setRetry] = useState(false)

  const { onRetry, error, isActive } = loader

  const onClick = useCallback(() => {
    if (onRetry) {
      if (onRetry.constructor.name === 'AsyncFunction') {
        setRetry(true)

        onRetry()
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            setRetry(false)
          })
      } else {
        onRetry()
      }
    }
  }, [onRetry])

  const goHome = useCallback(() => {
    navigate('/', { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isActive) {
    return null
  }

  return (
    <>
      {!error || (isRetry && <title>{error}</title>)}

      {error && !isRetry && <title>{error}</title>}

      <FullCenterContent fastAnimation>
        <div className={styles['fpl-block-logo']}>
          <img
            className={clsx(
              styles['fpl-block-logo__img'],
              DEFAULT_ANIMATION_IN
            )}
            src="/images/logo.png"
            alt="Logo"
          />
        </div>
        <div className={styles['fpl-content']}>
          {!error || isRetry ? (
            <NotchLoader />
          ) : (
            <div className={styles['fpl-actions']}>
              <Btn design={['primary']} onClick={onClick}>
                {t('buttons:refresh')}
              </Btn>
              <Btn design={['text-link']} onClick={goHome}>
                {t('buttons:goToMain')}
              </Btn>
            </div>
          )}
        </div>
        {error && (
          <div className={clsx(styles['fpl-block-info'], DEFAULT_ANIMATION_IN)}>
            {error}
          </div>
        )}
      </FullCenterContent>
    </>
  )
}

export const FullPageLoader = memo(FCFullPageLoader)
